import { memo } from 'react';
import AccessoryItem from './accessory_item';
import { IBotSection } from '../../models';

const AccessoryList = ({
  accessories,
  onRemove,
  onLocationChange,
  isLastSection = false,
  section,
  onSectionFieldChange,
  onAccessoryFieldChange,
  tunnelIndex,
  airflow_direction_id,
  tunnel_configuration
}: {
  accessories: IBotSection['accessories'];
  onRemove: (idx: number) => void;
  onLocationChange: (idx: number, loc: any) => void;
  isLastSection?: boolean;
  section: IBotSection;
  onSectionFieldChange?: (value: string | number | null, name: string) => void;
  onAccessoryFieldChange?: (
    idx: number,
    value: string | number | null,
    name: string,
  ) => void;
  tunnelIndex: number;
  airflow_direction_id?: number;
  tunnel_configuration: number
}) => {
  if (!accessories || accessories.length === 0)
    return (
      <ul className="list-style-none">
        <li className="bot-accessories__empty">No accessories added yet.</li>
      </ul>
    );

  return (
    <ul className="bot-accessories__list">
      {accessories.map((acc, idx) => (
        <AccessoryItem
          key={`${acc.type}-${idx}`}
          acc={acc}
          idx={idx}
          onRemove={onRemove}
          onLocationChange={onLocationChange}
          isLastSection={isLastSection}
          section={section}
          onSectionFieldChange={onSectionFieldChange}
          onAccessoryFieldChange={onAccessoryFieldChange}
          tunnelIndex={tunnelIndex}
          airflow_direction_id={airflow_direction_id}
          tunnel_configuration={tunnel_configuration}
        />
      ))}
    </ul>
  );
};

export default memo(AccessoryList);
